export const CONFIG = {
  "PROJECTNAME": "posuda",
  "COMPANYNAME": "Posuda",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10204001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgba(219, 45, 41, 1)",
    "primary100": "rgba(219, 45, 41, 0.1)",
    "light": "rgba(219, 45, 41, 1)",
    "secondary": "rgba(219, 45, 41, 1)",
    "dark": "rgba(219, 45, 41, 1)",
    "siteColor3": "#fff",
    "menuSecondary": "rgba(219, 45, 41, 1)"
  }
};